import React from 'react';
import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import { ListChecks } from 'lucide-react';
import { API } from '../governance_v2/constants';
import { ACTIVITY_STATUS, fmtDate } from './constants';

export const MyActivities = ({ companyId, onOpenProject }) => {
  const { data = [], isLoading } = useQuery({
    queryKey: ['my-activities', companyId],
    queryFn: async () => (await axios.get(`${API}/companies/${companyId}/my-activities`)).data.items,
    enabled: !!companyId,
  });
  return (
    <section className="rounded-xl border border-slate-200 p-4 dark:border-slate-700" data-testid="my-activities">
      <p className="mb-3 flex items-center gap-2 text-sm font-semibold"><ListChecks className="h-4 w-4 text-sky-500" />Mis actividades ({data.length})</p>
      {isLoading && <p className="text-sm text-slate-400">Cargando tus actividades…</p>}
      {!isLoading && !data.length && <p className="text-sm text-slate-500">No tienes actividades asignadas.</p>}
      <div className="space-y-2">{data.map((a) => (
        <button type="button" key={a.id} onClick={() => onOpenProject(a.project_id)} data-testid={`my-activity-${a.id}`}
          className="flex w-full items-center gap-3 rounded-lg border border-slate-200 p-3 text-left transition-colors duration-150 hover:bg-slate-50 dark:border-slate-800 dark:hover:bg-slate-800/50">
          <span className={`h-2 w-2 shrink-0 rounded-full ${ACTIVITY_STATUS[a.status].dot}`} />
          <span className="min-w-0 flex-1"><span className="block truncate text-sm font-medium">{a.title}</span>
            <span className="block truncate text-xs text-slate-500">{a.project_title} · vence {fmtDate(a.end_date)}</span></span>
          <span className="text-xs font-semibold">{a.progress}%</span>
        </button>
      ))}</div>
    </section>
  );
};
